import { ObjectFactory } from './object.factory';

/**
 * Minimal shape of Firebase Admin DecodedIdToken needed by our auth tests.
 * We define our own interface rather than importing from firebase-admin
 * to avoid adding firebase-admin as a dependency of lib-types.
 */
export interface FirebaseDecodedIdToken {
  aud: string;
  auth_time: number;
  email?: string;
  email_verified?: boolean;
  exp: number;
  firebase: {
    identities: Record<string, unknown>;
    sign_in_provider: string;
  };
  iat: number;
  iss: string;
  name?: string;
  sub: string;
  uid: string;
}

export class FirebaseDecodedIdTokenFactory extends ObjectFactory<FirebaseDecodedIdToken> {
  protected getDefaults(): FirebaseDecodedIdToken {
    const now = Math.floor(Date.now() / 1000);
    return {
      aud: 'pharos-dev-8d6e9',
      auth_time: now,
      email: 'test@example.com',
      email_verified: true,
      exp: now + 3600,
      firebase: {
        identities: {},
        sign_in_provider: 'microsoft.com',
      },
      iat: now,
      iss: 'https://securetoken.google.com/pharos-dev-8d6e9',
      name: 'Test User',
      sub: 'firebase-uid-001',
      uid: 'firebase-uid-001',
    };
  }
}

export const firebaseTokenFactory = new FirebaseDecodedIdTokenFactory();
